import { render, staticRenderFns } from "./Redeemption.vue?vue&type=template&id=3a3200ea&scoped=true&"
import script from "./redeemption.js?vue&type=script&lang=js&"
export * from "./redeemption.js?vue&type=script&lang=js&"
import style0 from "./Redeemption.vue?vue&type=style&index=0&id=3a3200ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3200ea",
  null
  
)

export default component.exports